import { useState } from "react";

const IMAGES = [
  { src: "/images/park-entrance.webp", caption: "Park Entrance", category: "park" },
  { src: "/images/park-bridge.webp", caption: "Garden Walkway", category: "park" },
  { src: "/images/park-roundabout.webp", caption: "Memorial Grounds", category: "park" },
  { src: "/images/columbarium-exterior.jpg", caption: "In Aeternum Columbarium", category: "columbarium" },
  { src: "/images/columbarium-interior.jpg", caption: "Columbarium Niche Halls", category: "columbarium" },
];

const FILTERS = [
  { key: "all", label: "All" },
  { key: "park", label: "Park Grounds" },
  { key: "columbarium", label: "Columbarium" },
];

export default function Gallery() {
  const [filter, setFilter] = useState("all");
  const visible = IMAGES.filter((i) => filter === "all" || i.category === filter);

  return (
    <section id="gallery" className="py-20 sm:py-28 px-4 sm:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center max-w-2xl mx-auto">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#C59B27]">Photo Gallery</p>
          <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-semibold text-[#0C2340] mt-4">
            See the Park for yourself
          </h2>
          <p className="mt-4 text-base text-zinc-600">
            Manicured lawns, towering palms, and the modern In Aeternum
            Columbarium — all waiting for your family back home.
          </p>
        </div>

        <div className="flex justify-center gap-3 mt-8">
          {FILTERS.map((f) => (
            <button
              key={f.key}
              data-testid={`gallery-filter-${f.key}`}
              onClick={() => setFilter(f.key)}
              className={`text-sm font-medium px-5 py-2 rounded-full transition-colors ${
                filter === f.key
                  ? "bg-[#0C2340] text-white"
                  : "bg-white border border-[#0C2340]/15 text-[#0C2340] hover:border-[#C59B27]"
              }`}
            >
              {f.label}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-10">
          {visible.map((img) => (
            <figure
              key={img.src}
              data-testid={`gallery-item-${img.caption.toLowerCase().replace(/\s+/g, "-")}`}
              className="group relative overflow-hidden rounded-2xl shadow-[0_4px_20px_rgba(12,35,64,0.06)] hover:shadow-[0_12px_32px_rgba(12,35,64,0.12)] transition-shadow duration-300"
            >
              <img
                src={img.src}
                alt={img.caption}
                className="w-full h-64 object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <figcaption className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-[#0C2340]/80 to-transparent text-white text-sm font-medium px-5 pt-10 pb-4">
                {img.caption}
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
